import getUserLicenseType from './getUserLicenseType';
import { lazyShowProofingLanguagePicker, lazyToggleProofingSetting } from '../index';
import { LicenseType } from './getUserLicenseType';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';
import { EditorViewState } from 'owa-editor';
import loc from 'owa-localize';
import {
    toggleSpelling,
    toggleGrammar,
    toggleWritingRefinement,
    changeProofingLanguage,
} from './subMenu.locstring.json';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    ProofingOptions,
} from 'owa-outlook-service-options';

export default function getSubMenuPropsForProofing(
    viewState: EditorViewState
): IContextualMenuProps {
    let subMenuProps: IContextualMenuProps;
    const proofingOptions = getOptionsForFeature<ProofingOptions>(OwsOptionsFeatureType.Proofing);

    subMenuProps = {
        items: [
            {
                name: loc(toggleSpelling),
                key: 'Spelling',
                canCheck: true,
                checked: proofingOptions.spellCheckEnabled,
                onClick: () => {
                    toggleProofingSetting(viewState, 'spelling');
                },
            },
            {
                name: loc(toggleGrammar),
                key: ' Grammar',
                canCheck: true,
                checked: proofingOptions.grammarEnabled,
                onClick: () => {
                    toggleProofingSetting(viewState, 'grammar');
                },
            },
        ],
    };

    if (getUserLicenseType() === LicenseType.Subscription) {
        subMenuProps.items.push({
            name: loc(toggleWritingRefinement),
            key: 'Refinements',
            canCheck: true,
            checked: proofingOptions.writingRefinementsEnabled,
            onClick: () => {
                toggleProofingSetting(viewState, 'refinements');
            },
        });
    }

    subMenuProps.items.push({
        name: loc(changeProofingLanguage),
        key: 'Language',
        onClick: () => {
            lazyShowProofingLanguagePicker
                .import()
                .then(showProofingLanguagePicker => showProofingLanguagePicker(viewState));
        },
    });

    return subMenuProps;
}

function toggleProofingSetting(viewState: EditorViewState, setting: string) {
    lazyToggleProofingSetting.import().then(toggleSetting => toggleSetting(viewState, setting));
}
